module.exports = __webpack_public_path__ + "img/small-pass3.0684cb7d.png";